'use strict';

const $ = require('dibs-jquery-shim');
const PortfolioItemCollection = require('./PortfolioItemCollection');
const CartPortfolioItem = require('bunsen/models/portfolio/CartPortfolioItemModel');
const Items = require('bunsen/collections/inventory/Items');
const Storage = require('bunsen/helpers/storage');
const User = require('bunsen/models/identity/User');
const bunsen = require('bunsen/libraries/bunsen');
const endpoints = require('dibs-endpoints');
const countStorage = Storage.sessionStorage;

const ServiceCartCollection = module.exports = PortfolioItemCollection.extend({
    model: CartPortfolioItem,
    url() {
        return bunsen.extendURL(endpoints.cartPortfolio(User.getUserId()), {type: 'CART', loadItems: 'Y'});
    },

    comparator(modelOne, modelTwo) {
        return modelTwo.get('id') - modelOne.get('id');
    },

    fetch(options) {
        const numItems = options ? options.numberOfItems : false;
        let fetchPromise;
        if (numItems && numItems < this.length) {
            fetchPromise = this._fetchSome(numItems);
        } else {
            fetchPromise = ServiceCartCollection.__super__.fetch.call(this, Object.assign({ silent: true }, options));
        }
        // Make this a feature for other collections to make use of?
        return fetchPromise.then(() => this.checkStaleData.call(this, options) || fetchPromise);
    },

    _fetchSome(numItems) {
        let itemIdsArr;
        let appendItemIdsArr;
        let items;

        if (!this.length) {
            return $.Deferred().resolve();
        }
        itemIdsArr = this.map(function (item) { return item.get('item.id'); });
        items = new Items();
        itemIdsArr = itemIdsArr.slice(-numItems);
        appendItemIdsArr = itemIdsArr.slice(0, -numItems);
        items.setParam('pk', itemIdsArr.join(' '), {filterQuery: true});
        return items.fetchWithParameters().done(data => {
            this.reset(
                data.result.items
                    .map(item => new CartPortfolioItem({ item }))
                    .concat(appendItemIdsArr.map(itemId => new CartPortfolioItem({ item: { id: itemId }}))));
        });
    },

    checkStaleData(options) {
        // Necessary to handle stale data caused by bfcache in firefox/safari
        const storedCount = countStorage.getItem('cartCount');
        options = options || {};
        if (!(typeof storedCount === 'number') || options.numberOfItems < this.length) {
            return false;
        }
        if (storedCount !== this.length) {
            countStorage.deleteItem('cartCount');
            return this.fetch(options);
        }
        return false;
    },

    add(model, options) {
        let cartPortfolioItem;
        let ret;

        if (Array.isArray(model)) {
            model.forEach(singleModel => this.add(singleModel, options));
            return true;
        }
        if (model instanceof CartPortfolioItem) {
            cartPortfolioItem = model;
        } else {
            cartPortfolioItem = new CartPortfolioItem();
            cartPortfolioItem.set({ item: model });
            cartPortfolioItem.save({ 'item.id': model.get('id') });
        }
        ret = ServiceCartCollection.__super__.add.call(this, cartPortfolioItem, options);
        countStorage.setItem('cartCount', this.length);
        return ret;
    },

    remove(model, options) {
        let ret;
        if (Array.isArray(model)) {
            model.forEach(singleModel => this.remove(singleModel, options));
            return false;
        }
        ret = ServiceCartCollection.__super__.remove.call(this, model, options);
        countStorage.setItem('cartCount', this.length);
        return ret;
    }
});



// WEBPACK FOOTER //
// ./~/bunsen/collections/portfolio/ServiceCartCollection.es.js